import ApplicationComponent from "legacy/ApplicationComponent"
import DatePicker from "legacy/DatePicker"
import FormGroup from "legacy/FormGroup"
import LegacyButton from "legacy/LegacyButton"
import ContractGroupV2PanelPage from "legacy/contract-groups-v2/ContractGroupV2PanelPage"
import { validatorFactory } from "legacy/validatorFactory"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

// Note: Amplitude is loaded globally

class ContractGroupV2Billing extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.validator = validatorFactory({ autoForceUpdate: this })
    const form = props.form
    this.state = {
      customBillingPeriod: form.customBillingPeriod || false,
      billingCycle: form.billingCycle || "first_of_month",
      billingStartDate: form.billingStartDate || "",
      billingEndDate: form.billingEndDate || "",
    }

    this.next = this.next.bind(this)
    this.handleCustomBillingDatesToggle =
      this.handleCustomBillingDatesToggle.bind(this)
  }

  fetchData() {
    return this.state
  }

  componentWillUnmount() {
    Amplitude.trackEvent("contracts_v2:billing_complete")
    this.props.update(this.state)
  }

  next() {
    this.props.route.goNext()
  }

  isFirstOfMonth() {
    return this.state.billingCycle === "first_of_month"
  }

  isUpfront() {
    return this.state.billingCycle === "upfront"
  }

  isHalfAndHalf() {
    return this.state.billingCycle === "half_and_half"
  }

  handleCustomBillingDatesToggle(event) {
    const checked = event.target.checked
    if (checked) {
      this.setState({ customBillingPeriod: checked })
    } else {
      this.setState({
        customBillingPeriod: checked,
        billingStartDate: "",
        billingEndDate: "",
      })
    }
  }

  render() {
    return (
      <ContractGroupV2PanelPage
        hasNext={this.props.route.hasNext}
        hasPrevious={this.props.route.hasPrevious}
        goNext={this.next}
        goPrevious={this.props.route.goPrevious}
        saving={this.props.saving}
      >
        <div className="form-group">
          <div>
            <label htmlFor="billing-cycle">Billing Cycle</label>
          </div>
          <div id="billing-cycle" className="space-x-2">
            <LegacyButton
              type={this.isFirstOfMonth() ? "primary" : ""}
              onClick={() => this.setState({ billingCycle: "first_of_month" })}
            >
              First of The Month
            </LegacyButton>
            <LegacyButton
              type={this.isUpfront() ? "primary" : ""}
              disabled={this.props.form.contractType === "month_to_month"}
              onClick={() => this.setState({ billingCycle: "upfront" })}
            >
              100% Upfront
            </LegacyButton>
            <LegacyButton
              type={this.isHalfAndHalf() ? "primary" : ""}
              disabled={this.props.form.contractType === "month_to_month"}
              onClick={() => this.setState({ billingCycle: "half_and_half" })}
            >
              Half and half
            </LegacyButton>
            {this.validator.message(
              "billingCycle",
              this.state.billingCycle,
              "required"
            )}
          </div>
        </div>
        {(this.isUpfront() || this.isHalfAndHalf()) && (
          <div className="form-group mt-4">
            <label htmlFor="customBillingPeriod">Custom Billing Period</label>
            <div className="flex space-x-2">
              <FormGroup
                inputType="checkbox"
                name="customBillingPeriod"
                value={this.state.customBillingPeriod}
                onChange={this.handleCustomBillingDatesToggle}
                label="Set custom billing dates"
              />
            </div>
          </div>
        )}
        {(this.isUpfront() || this.isHalfAndHalf()) &&
          this.state.customBillingPeriod && (
            <div className="row form-row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label>
                    {this.isHalfAndHalf()
                      ? "50% Deposit Date"
                      : "Billing Start Date"}
                  </label>
                  <div className="form-control-with-icon">
                    <i className="fa-kit fa-calendar form-control-icon-left" />
                    <DatePicker
                      setParentState={(date) =>
                        this.setState({ billingStartDate: date })
                      }
                      value={
                        this.state.billingStartDate &&
                        moment(this.state.billingStartDate).format("L")
                      }
                    />
                  </div>
                </div>
              </div>
              {this.isHalfAndHalf() && (
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>
                      {this.isHalfAndHalf()
                        ? "Remaining 50% Date"
                        : "Billing End Date"}
                    </label>
                    <div className="form-control-with-icon">
                      <i className="fa-kit fa-calendar form-control-icon-left" />
                      <DatePicker
                        setParentState={(date) =>
                          this.setState({ billingEndDate: date })
                        }
                        value={
                          this.state.billingEndDate &&
                          moment(this.state.billingEndDate).format("L")
                        }
                        startDate={moment(this.state.billingStartDate).format(
                          "L"
                        )}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        {this.isHalfAndHalf() && !this.state.customBillingPeriod && (
          <div>
            <div className="form-group">
              <p className="text-muted">
                Customer will be billed in 2 equal installments
              </p>
              <div id="billing-cycle" className="flex items-center space-x-2">
                <LegacyButton disabled>1st</LegacyButton>
                <span className="flex-1">installment paid upon signing</span>
              </div>
            </div>
            <div className="form-group">
              <div id="billing-cycle" className="flex items-center space-x-2">
                <LegacyButton disabled>2nd</LegacyButton>
                <span className="flex-1">
                  installment paid on contract start date
                </span>
              </div>
            </div>
          </div>
        )}
      </ContractGroupV2PanelPage>
    )
  }
}

ContractGroupV2Billing.propTypes = {
  form: PropTypes.shape({
    customBillingPeriod: PropTypes.bool,
    billingCycle: PropTypes.string,
    billingStartDate: PropTypes.string,
    billingEndDate: PropTypes.string,
    contractType: PropTypes.string,
  }).isRequired,
  update: PropTypes.func.isRequired,
  route: PropTypes.shape({
    hasNext: PropTypes.bool,
    hasPrevious: PropTypes.bool,
    goNext: PropTypes.func,
    goPrevious: PropTypes.func,
  }).isRequired,
  saving: PropTypes.bool,
}

export default ContractGroupV2Billing
